import { Component, OnInit, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-roy-cultivos-etiquetador",
  templateUrl: "./cultivos-etiquetador.component.html",
})
export class RoyaltiesEtiquetadorCultivosComponent implements OnInit {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;
  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public readonly visiblePages = 3;

  public cultivosEtiquetador;
  public _cultivos;
  public _unidadesMedida;

  @Input() set cultivos(_cultivosEtiquetador){
    this._cultivos = _cultivosEtiquetador;
    this.totalItems = this._cultivos.length;
    this.cultivosEtiquetador = this._cultivos.slice(0,this.itemsPerPage);
    this.pageChange(1);
  };

  @Input() set unidadesMedida(_unidades){
    this._unidadesMedida = _unidades;
  };

  constructor(private readonly _translate: TranslateService) {}

  ngOnInit() {  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.firstItemList + this.itemsPerPage;
    this.cultivosEtiquetador = this._cultivos.slice(this.firstItemList, this.lastItemList);
  }
}
